import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserSessionService } from '../services/auth/user-session.service';
import { AppAuthService } from '../services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private appAuthService: AppAuthService,
    private userSession: UserSessionService,
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.appAuthService.getAuthData()) {
      if (!this.userSession.getUserInfo()) {
        const _data = atob(this.appAuthService.getAuthData());
        const cookieAuthData = JSON.parse(_data);
        const isGoogleUser = cookieAuthData.un === '' && cookieAuthData.pw === '';
        if (isGoogleUser) {
          return this.appAuthService
            .logInAuthGoogle(this.appAuthService.decryptUsingAES256(cookieAuthData.em), this.appAuthService.decryptUsingAES256(cookieAuthData.tk))
            .pipe(
              map(response => {
                return true;
              }),
            );
        } else {
          return this.appAuthService
            .logInAuth(this.appAuthService.decryptUsingAES256(cookieAuthData.un), this.appAuthService.decryptUsingAES256(cookieAuthData.pw))
            .pipe(
              map(response => {
                return true;
              }),
            );
        }
      } else {
        return true;
      }
    } else {
      this.router.navigate(['auth/login'], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }
  }

}
